import React, { useEffect, useState } from "react";
import {
  Button,
  Modal,
  Collapse,
  Radio,
  Form,
  Input,
  Select,
  Upload,
  Tag,
  Flex,
} from "antd";
import {
  UploadOutlined,
  FilePdfOutlined,
  FileTextOutlined,
  LinkOutlined,
  FileExcelOutlined,
} from "@ant-design/icons";
import "./trainContent.scss";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getRoles } from "../../../redux/slices/userManagementSlice";
import TextArea from "antd/es/input/TextArea";
import {
  setSelectedTrainStatus,
  uploadTrainingData,
} from "../../../redux/slices/trainAndContentSlice";
import PreviewPopup from "./PreviewPopup";

const { Panel } = Collapse;

const TrainAndContentPopup = ({ isOpen, setIsOpen, selectedType = "text" }) => {
  const { user } = useSelector((state) => state.profileReducer);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const getActiveKey = (type) => {
    switch (type) {
      case "text":
        return "1";
      case "url":
        return "2";
      case "pdf":
        return "3";
      case "csv":
        return "4";
      default:
        return "1";
    }
  };
  const [activeKey, setActiveKey] = useState(getActiveKey(selectedType));
  const [selectedRoles, setSelectedRoles] = useState([]);
  const [fileName, setFileName] = useState("");
  const [textName, setTextName] = useState("");
  const [textDescp, setTextDesp] = useState("");
  const [urlName, setUrlName] = useState("");
  const [urlLink, setUrlLink] = useState("");
  const [isPreview, setIsPreview] = useState(false);
  const [activePayload, setIsActivePayload] = useState({});
  const [addDscription, setDescription] = useState("");
  const [pdfSelect, setPdfSelect] = useState(null);
  const [csvXlsxFileName, setCsvXlsxFileName] = useState("");
  const [csvXlsxFile, setCsvXlsxFile] = useState(null);
  const [isNextDisabled, setIsNextDisabled] = useState(true);
  const { getRolesData } = useSelector((state) => state.userManagementReducer);
  const [errors, setErrors] = useState({ textName: "" });
  const [category, setCategory] = useState("");
  const [childCompanyName, setChildCompanyName] = useState("");
  const [region, setRegion] = useState("");
  const [country, setCountry] = useState("");
  const { page, limit, searchInput } = useSelector(
    (state) => state.globalReducer,
  );

  const handleOk = () => {
    setIsOpen(false);
    setTextName("");
    setTextDesp("");
    setSelectedRoles([]);
    setUrlLink("");
    setUrlName("");
    setPdfSelect(null);
    setCsvXlsxFile(null);
    setCsvXlsxFileName("");
    setFileName("");
    setChildCompanyName("");
    setRegion("");
    setCountry("");
    setCategory("");
  };

  const handleCancel = () => {
    setIsOpen(false);
    setTextName("");
    setTextDesp("");
    setSelectedRoles([]);
    setUrlLink("");
    setUrlName("");
    setPdfSelect(null);
    setCsvXlsxFile(null);
    setCsvXlsxFileName("");
    setFileName("");
    setChildCompanyName("");
    setRegion("");
    setCountry("");
    setCategory("");
  };

  const options = getRolesData?.data?.map((role) => ({
    value: role.name,
    label: role.name,
  }));

  const handleFileChange = (info) => {
    const file = info.file;
    if (file) {
      setFileName(file.name);
      setPdfSelect(file);
    } else {
      setFileName("");
      setPdfSelect(null);
    }
  };

  const handleCsvXlsxChange = (info) => {
    const file = info.file;

    if (file) {
      setCsvXlsxFileName(file.name);
      setCsvXlsxFile(file);
    } else {
      setCsvXlsxFileName("");
      setCsvXlsxFile(null);
    }
  };

  const handleChangeText = (e) => {
    const { value } = e.target;
    if (value.length > 50) {
      setErrors({
        ...errors,
        textName: "Name cannot exceed 50 characters",
      });
    } else {
      setErrors({
        textName: "",
      });
    }
    setTextName(value);
  };

  const isCardekho =
    user?.organisationName?.trim()?.toLowerCase() === "cardekho";

  const items = [
    {
      key: "1",
      label: "TEXT",
      icon: <FileTextOutlined />,
      onClickContent: () => {
        dispatch(setSelectedTrainStatus("text"));
      },
      children: () => {
        return (
          <div>
            <Form.Item required label="Enter text file name" layout="vertical">
              <Input
                placeholder="Enter file name"
                name="textName"
                value={textName}
                onChange={handleChangeText}
                showCount
              />
              {errors.textName && (
                <span className="error-message">{errors.textName}</span>
              )}
            </Form.Item>
            <Form.Item required label="Select Roles" layout="vertical">
              <Select
                size="large"
                mode="multiple"
                value={selectedRoles}
                onChange={(values) => setSelectedRoles(values)}
                style={{ width: "100%" }}
                options={options}
              />
            </Form.Item>
            <Form.Item
              required
              label="Please Enter description here"
              layout="vertical"
            >
              <TextArea
                rows={4}
                placeholder="Content"
                name="textDescp"
                value={textDescp}
                onChange={(e) => setTextDesp(e.target.value)}
              />
            </Form.Item>
          </div>
        );
      },
    },
    {
      key: "2",
      label: "URL",
      icon: <LinkOutlined />,
      onClickContent: () => {
        dispatch(setSelectedTrainStatus("url"));
      },
      children: () => {
        return (
          <div>
            <Form.Item required label="Enter URL Name" layout="vertical">
              <Input
                value={urlName}
                onChange={(e) => setUrlName(e.target.value)}
                placeholder="Enter URL Name"
              />
            </Form.Item>
            <Form.Item required label="Select Roles" layout="vertical">
              <Select
                size="large"
                mode="multiple"
                value={selectedRoles}
                onChange={(values) => setSelectedRoles(values)}
                style={{ width: "100%" }}
                options={options}
              />
            </Form.Item>
            <Form.Item required label="Enter URL Link" layout="vertical">
              <Input
                value={urlLink}
                onChange={(e) => setUrlLink(e.target.value)}
                placeholder="Enter URL Link"
              />
            </Form.Item>
          </div>
        );
      },
    },
    {
      key: "3",
      label: "PDF",
      icon: <FilePdfOutlined />,
      onClickContent: () => {
        dispatch(setSelectedTrainStatus("pdf"));
      },
      children: () => {
        return (
          <div>
            <Form.Item required label="Select Roles" layout="vertical">
              <Select
                size="large"
                mode="multiple"
                value={selectedRoles}
                onChange={(values) => setSelectedRoles(values)}
                style={{ width: "100%" }}
                options={options}
              />
            </Form.Item>
            <Form.Item required label="Select Category" layout="vertical">
              <Select
                size="large"
                // mode="multiple"
                value={category}
                onChange={(values) => setCategory(values)}
                style={{ width: "100%" }}
                options={[
                  { value: "IT", label: "IT" },
                  { value: "HR", label: "HR" },
                  { value: "General", label: "General" },
                  { value: "Reimbursement", label: "Reimbursement" },
                ]}
              />
            </Form.Item>
            {isCardekho && (
              <>
                <Form.Item label="Child Company Name" layout="vertical">
                  <Input
                    placeholder="Enter Child Company Name"
                    size="large"
                    value={childCompanyName}
                    onChange={(e) => setChildCompanyName(e.target.value)}
                  />
                </Form.Item>
                <Form.Item label="Country" layout="vertical">
                  <Input
                    placeholder="Enter Country Name"
                    size="large"
                    value={country}
                    onChange={(e) => setCountry(e.target.value)}
                  />
                </Form.Item>
                <Form.Item label="Region" layout="vertical">
                  <Input
                    placeholder="Enter Region Name"
                    size="large"
                    value={region}
                    onChange={(e) => setRegion(e.target.value)}
                  />
                </Form.Item>
              </>
            )}
            <Form.Item
              required
              label="Attach or Browse PDF (Max Size: 10MB)"
              layout="vertical"
            >
              <Flex vertical style={{ width: "100%" }}>
                <Upload
                  accept=".pdf"
                  showUploadList={false}
                  beforeUpload={() => false}
                  onChange={handleFileChange}
                  style={{ width: "100%" }}
                >
                  <Button
                    style={{ width: "100%", padding: "20px" }}
                    icon={<UploadOutlined />}
                    type="primary"
                  >
                    Attach or Browse PDF
                  </Button>
                </Upload>
              </Flex>
              {fileName && (
                <div
                  style={{
                    marginLeft: 16,
                    marginTop: 10,
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <FilePdfOutlined
                    style={{ fontSize: 20 }}
                    className="pdf-icon"
                  />
                  <span style={{ marginLeft: 8, wordBreak: "break-all" }}>
                    {fileName}
                  </span>
                </div>
              )}
            </Form.Item>
          </div>
        );
      },
    },
    {
      key: "4",
      label: "CSV/XLSX",
      icon: <FileExcelOutlined />,
      onClickContent: () => {
        dispatch(setSelectedTrainStatus("csv"));
      },
      children: () => {
        return (
          <div>
            <Form.Item required label="Select Roles" layout="vertical">
              <Select
                size="large"
                mode="multiple"
                value={selectedRoles}
                onChange={(values) => setSelectedRoles(values)}
                style={{ width: "100%" }}
                options={options}
              />
            </Form.Item>
            <Form.Item
              required
              label="Attach or Browse Excel/CSV File (Max Size: 10MB)"
              layout="vertical"
            >
              <Flex vertical style={{ width: "100%" }}>
                <Upload
                  accept=".csv,.xlsx,.xls"
                  showUploadList={false}
                  beforeUpload={() => false}
                  onChange={handleCsvXlsxChange}
                  style={{ width: "100%" }}
                >
                  <Button
                    style={{ width: "100%", padding: "20px" }}
                    icon={<UploadOutlined />}
                    type="primary"
                  >
                    Attach or Browse CSV File
                  </Button>
                </Upload>
              </Flex>
              {csvXlsxFileName && (
                <div
                  style={{
                    marginLeft: 16,
                    marginTop: 10,
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <FileExcelOutlined
                    style={{ fontSize: 20 }}
                    className="excel-icon"
                  />
                  <span style={{ marginLeft: 8, wordBreak: "break-all" }}>
                    {csvXlsxFileName}
                  </span>
                </div>
              )}
            </Form.Item>
          </div>
        );
      },
    },
  ];

  const handleChange = (key) => {
    setActiveKey((prevKey) => (prevKey === key ? prevKey : key));
    setSelectedRoles([]);
    setCategory("");
    setChildCompanyName("");
    setRegion("");
    setCountry("");
  };

  const handleSubmit = () => {
    const formData = new FormData();
    const fileToUpload = activeKey?.[0] === "3" ? pdfSelect : csvXlsxFile;
    if (fileToUpload) {
      formData.append("file", fileToUpload);
    }
    formData.append(
      "role",
      JSON.stringify(
        Array.isArray(selectedRoles) ? selectedRoles : [selectedRoles],
      ),
    );
    if (activeKey?.[0] === "3") {
      formData.append("category", category);
      if (childCompanyName) {
        formData.append("child_company_name", childCompanyName);
      }
      if (country) {
        formData.append("country", country);
      }
      if (region) {
        formData.append("region", region);
      }
    }

    const payloads = {
      1: {
        // Text
        body: {
          textFileName: textName,
          role: selectedRoles,
          text: textDescp,
        },
        fileType: "text",
      },
      2: {
        // URL
        body: {
          role: selectedRoles,
          url: urlLink,
          urlFileName: urlName,
        },
        fileType: "url",
      },
      3: {
        // PDF
        body: formData,
        fileType: "pdf",
      },
      4: {
        // CSV/XLSX
        body: formData,
        fileType: "csv",
      },
    };
    const { body, fileType } = payloads[activeKey] || {};

    setIsActivePayload(body);
    const key = Array.isArray(activeKey) ? activeKey[0] : activeKey;
    setDescription(
      key === 1
        ? textDescp
        : key === 2
          ? urlLink
          : key === 3
            ? fileName
            : csvXlsxFileName,
    );
    setIsPreview(true);
    setIsOpen(false);
  };
  const validateForm = () => {
    // Check if any field in the active payload is empty
    const key = Array.isArray(activeKey) ? activeKey[0] : activeKey;
    let isFormValid = false;

    if (key == 1) {
      isFormValid = textName && textDescp && selectedRoles.length > 0;
    } else if (key == 2) {
      isFormValid = urlName && urlLink && selectedRoles.length > 0;
    } else if (key == 3) {
      isFormValid = fileName && selectedRoles.length > 0;
    } else if (key == 4) {
      isFormValid = csvXlsxFileName && selectedRoles.length > 0;
    }
    setIsNextDisabled(!isFormValid);
  };

  const onSubmitTrainContent = () => {
    let status =
      activeKey == 1
        ? "text"
        : activeKey == 2
          ? "url"
          : activeKey == 3
            ? "pdf"
            : "csv";
    dispatch(
      uploadTrainingData({
        body: activePayload,
        fileType: status,
        page: page,
        limit: limit,
        navigate: navigate,
        searchQuery: searchInput || "",
      }),
    );
    setIsOpen(false);
    setTextName("");
    setTextDesp("");
    setSelectedRoles([]);
    setUrlLink("");
    setUrlName("");
    setPdfSelect(null);
    setFileName("");
    setCsvXlsxFile(null);
    setCsvXlsxFileName("");
    setCategory("");
    setChildCompanyName("");
    setRegion("");
    setCountry("");
  };

  const onClose = () => {
    setIsOpen(false);
    setTextName("");
    setTextDesp("");
    setSelectedRoles([]);
    setUrlLink("");
    setUrlName("");
    setPdfSelect(null);
    setFileName("");
    setCsvXlsxFile(null);
    setCsvXlsxFileName("");
    setCategory("");
    setChildCompanyName("");
    setRegion("");
    setCountry("");
  };

  useEffect(() => {
    validateForm();
  }, [
    textName,
    textDescp,
    urlName,
    urlLink,
    fileName,
    csvXlsxFileName,
    selectedRoles,
  ]);

  useEffect(() => {
    dispatch(getRoles({ navigate: navigate }));
  }, [dispatch, navigate]);
  useEffect(() => {
    if (isOpen) {
      setActiveKey(getActiveKey(selectedType));
    }
  }, [isOpen, selectedType]);
  return (
    <>
      <Modal
        width={`30%`}
        centered
        title="Add Training Data"
        open={isOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={
          <div className="preview-btn">
            <Button className={"custom-btn"} onClick={handleCancel}>
              Close
            </Button>
            <Button
              className={"custom-btn"}
              disabled={isNextDisabled}
              onClick={handleSubmit}
            >
              Next
            </Button>
          </div>
        }
      >
        <Collapse
          activeKey={[activeKey]}
          onChange={handleChange}
          accordion
          expandIcon={({ isActive }) => <Radio checked={isActive} />}
          expandIconPosition="right"
          className="custom-collapse"
        >
          {items.map((item) => (
            <Panel
              key={item.key}
              header={
                <div onClick={item?.onClickContent} className="collapse-header">
                  <span className="header-title">
                    <Tag>{item.icon}</Tag>
                    {item.label}
                  </span>
                </div>
              }
            >
              {item.children()}
            </Panel>
          ))}
        </Collapse>
      </Modal>
      <PreviewPopup
        isOpen={isPreview}
        setIsOpen={setIsPreview}
        description={addDscription}
        onSubmit={onSubmitTrainContent}
        pdfSelect={pdfSelect}
        onCancel={handleCancel}
      />
    </>
  );
};

export default TrainAndContentPopup;
